import { MAP_BOUNDS_UPDATED, MAP_VISIBILITY_UPDATED } from '../actions/map';
import { isDesktop } from '../../../../js/util/dom'

const map = (
  state = {
    event: null,
    bounds: null,
    visible: isDesktop(),
    timeStamp: null
  },
  action
) => {
  switch (action.type) {
    case MAP_BOUNDS_UPDATED:
      return Object.assign({}, state, {
        event: action.event,
        bounds: action.newMapBounds,
        timeStamp: new Date().getTime()
      });
    case MAP_VISIBILITY_UPDATED:
      return Object.assign({}, state, {
        visible: action.newVisibility
      });
    default:
      return state;
  }
};

export default map;
